<h1>Export rewards</h1>

<div *ngIf="!showNotFoundMsg">
  <app-bidirectional-selection [rewardList]="rewardsList" [currentSegment]="'export'" (sendRewardList)="exportToJSON($event, 'rewards')"></app-bidirectional-selection>
</div>

<div *ngIf="showNotFoundMsg">
  <p>No data...</p>
</div>
